import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = async (url: any, params: any) => {
    let response;

    let paramKeys: any = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = async (url: any, data: any) => {
    try {
      return await axios.post(url, data);
    } catch (error: any) {
      if (error.response) {
        return error.response;
      }
      throw error;
    }
  };
  /**
   * post given form data to url
   */
  createFormData = async (url: any, data: any) => {
    return axios.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
  /**
   * Updates data
   */
  update = async (url: any, data: any) => {
    return axios.patch(url, data);
  };

  put = async (url: any, data: any) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = async (
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, getLoggedinUser };
